import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "96",
  height: "96",
  "aria-label": "Success",
  viewBox: "0 0 96 96"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [
        _createTextVNode("@keyframes pop{0%{transform:scale(.2);opacity:0}60%{transform:scale(1.15);opacity:1}85%{transform:scale(.96)}to{transform:scale(1)}}@keyframes draw{to{stroke-dashoffset:0}}")
      ])),
      _: 1,
      __: [0]
    })),
    _cache[1] || (_cache[1] = _createElementVNode("g", { style: {"transform-origin":"48px 48px","animation":"pop 420ms cubic-bezier(.2,1.4,.4,1) both"} }, [
      _createElementVNode("circle", {
        cx: "48",
        cy: "48",
        r: "30",
        fill: "#58C232"
      }),
      _createElementVNode("path", {
        d: "m36 49 8 8 16-17",
        style: {"fill":"none","stroke":"#fff","stroke-width":"8","stroke-linecap":"round","stroke-linejoin":"round","stroke-dasharray":"80","stroke-dashoffset":"80","animation":"draw 260ms ease-out 220ms both"}
      })
    ], -1))
  ]))
}
export default { render: render }